import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/mine/search.png';

const _withScopeId = n => (_pushScopeId("data-v-145a03fc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "videoSearch"
};
const _hoisted_2 = {
  class: "head_title"
};
const _hoisted_3 = {
  class: "searchHeader-input"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

const _hoisted_5 = {
  class: "cont webkit-overflow-scrolling-touch"
};
const _hoisted_6 = {
  class: "cont_item"
};
const _hoisted_7 = {
  class: "title"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 搜索历史 ");

const _hoisted_9 = {
  class: "label_list"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "cont_item"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "热门标签", -1));

const _hoisted_13 = {
  class: "label_list"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "details_page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_search_popup = _resolveComponent("search-popup");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"]), _createElementVNode("div", _hoisted_3, [_hoisted_4, _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.searchTexts = $event),
    placeholder: "视频｜用户"
  }, null, 512), [[_vModelText, $setup.searchTexts]])]), _createElementVNode("span", {
    class: "btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.search && $setup.search(...args))
  }, "搜索")]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", {
    class: "del",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.clear && $setup.clear(...args))
  }, "清除")]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchLabels, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "label_item",
      onClick: $event => $setup.labelSearch({
        name: item
      }),
      key: item
    }, _toDisplayString(item), 9, _hoisted_10);
  }), 128))])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotLabel, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "label_item",
      onClick: $event => $setup.labelSearch(item),
      key: item.id
    }, _toDisplayString(item.name), 9, _hoisted_14);
  }), 128))])])]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $setup.showDetailsPopul = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [(_openBlock(), _createBlock(_component_search_popup, {
      searchText: $setup.searchText,
      key: $setup.key,
      label_id: $setup.label_id,
      onClose: $setup.close1
    }, null, 8, ["searchText", "label_id", "onClose"]))])]),
    _: 1
  }, 8, ["show"])]);
}